import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locationsList: [],
  permissionList: [],
  refreshApiCallLocation: true,
  refreshApiCallPermission: true,
  userTypeData: [],
  userType: null,
};

export const persistApiDataSlice = createSlice({
  name: "persistApiData",
  initialState,
  reducers: {
    setLocationsList(state, action) {
      state.locationsList = action.payload;
    },
    setPermissionList(state, action) {
      state.permissionList = action.payload;
    },
    setRefreshApiCallLocation(state, action) {
      state.refreshApiCallLocation = action.payload;
    },
    setRefreshApiCallPermission(state, action) {
      state.refreshApiCallPermission = action.payload;
    },
    setUserTypeData(state, action) {
      state.userTypeData = action.payload;
    },
    setUserType(state, action) {
      state.userType = action.payload;
    },
  },
});

export const {
  setLocationsList,
  setPermissionList,
  setRefreshApiCallLocation,
  setRefreshApiCallPermission,
  setUserTypeData,
  setUserType,
} = persistApiDataSlice.actions;

export default persistApiDataSlice.reducer;
